var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"controls"},[_c('button',{class:[
         'control-btn',
         {
            active: _vm.mode === 'plaintext',
            'control-btn--light-mode': !_vm.darkMode,
         } ],on:{"click":function($event){return _vm.changePreviewMode('plaintext')}}},[_vm._v("\n      Plaintext\n   ")]),_c('button',{class:[
         'control-btn',
         {
            active: _vm.mode === 'markdown',
            'control-btn--light-mode': !_vm.darkMode,
         } ],on:{"click":function($event){return _vm.changePreviewMode('markdown')}}},[_vm._v("\n      Markdown\n   ")])])}
var staticRenderFns = []

export { render, staticRenderFns }